<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>people</md-icon>
          </div>
          <h4 class="title pull-right">
            <router-link to="/admin/customer/new">
              <md-button class="md-success md-sm ">
                Incluir
                <span class="md-label">
                  <md-icon class="material-icons">plus_one</md-icon>
                </span>
              </md-button>
            </router-link>
          </h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="tableData" table-header-color="green">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="ID">{{ item.id }}</md-table-cell>
              <md-table-cell md-label="Nome">{{ item.name | uppercase }}</md-table-cell>              
              <md-table-cell md-label="Telefone">
                {{ item.phoneNumber }}
              </md-table-cell>
              <md-table-cell md-label="Status">
                {{ item.isActive ? 'ATIVO' : 'INATIVO' }}
              </md-table-cell>
              <md-table-cell md-label="Cidade">
                <div class="text-center h6">
                  {{ item.city }} - {{item.state}}
                </div>
              </md-table-cell>
              <md-table-cell md-label="Ações">
                <router-link :to="'/admin/customer/' + item.id">
                  <md-button class="md-just-icon md-info">
                    <md-icon>edit</md-icon>
                  </md-button>
                </router-link>
                <md-button class="md-just-icon md-default" @click="setStatus(item)">
                  <md-icon>{{ item.ativo ? 'toggle_off' : 'toggle_on' }}</md-icon>
                </md-button>
                <md-button class="md-just-icon md-danger" @click="deleteItem(item)">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>

import api from './../../services/api';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      tableData: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      api.get('/customers')
        .then(value => {
          const { data } = value;
          this.tableData = data;
        })
        .catch(error => console.log(error));
    },
    setStatus(item) {

    },
    deleteItem(item) {
      if (item.quantidade > 0) {
        this.notify('Não é possível excluir um medicamento em uso por algum paciente, você deve inativá-lo!');
        return;
      }
      Swal.fire({
        title: "Deseja mesmo excluir?",
        text: `${item.name}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-info",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "SIM",
        cancelButtonText: "NÂO",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          api.delete(`/customers/${item.id}`)
            .then(value => this.getData())
            .catch(error => console.log(error));
        }
      });
    },
    notify(message) {
      this.$notify({
        timeout: 2500,
        message,
        icon: "add_alert",
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'warning',
      });
    }
  },
};
</script>
<style scoped>
.table-transparent {
  background-color: transparent !important;
}

.mt-0 {
  margin-top: 0 !important;
}
</style>
